export default "__VITE_ASSET__BfVXfnt7__"